<div class="sms-form-container" #resetContainer>
    <div class="d-flex flex-column">
        <div class="d-flex py-3">
<!--            <img src="assets/img/locked-64.png"-->
<!--                width="36"-->
<!--                height="36"-->
<!--                alt />-->
            <span class="material-symbols-rounded square-icon">key</span>
            <p class="x-small-text spaced-label text-uppercase my-auto ms-3">Verificar cuenta</p>
        </div>
    </div>
    <p class="small-label" *ngIf="componentState !== 'codeOk'">
        Escribe el código de verificación envíado al {{ (channel === 'sms' || channel === 'wa') ? 'número de teléfono' : 'correo electrónico' }}.
    </p>
    <p class="small-label" *ngIf="componentState === 'codeOk'">
        Se ha verificado correctamente {{ (channel === 'sms' || channel === 'wa') ? 'número de teléfono' : 'correo electrónico' }}.
    </p>
    <!-- <p class="small-label" *ngIf="componentState === 'resendingCode'">
        Detectamos que la cuenta ya existe y no fue activada, enviamos un código
        de verificación al número de teléfono que registró para activar la
        cuenta.
    </p> -->
    <span class="py-3 x-small-text spaced-label text-uppercase" *ngIf="channel === 'sms' || channel === 'wa'">
        {{ data | mask : (country === 'mexico' ? '00 (000) 000-0000' : '0 (000) 000-0000') }}
    </span>
    <span class="py-3 x-small-text spaced-label text-uppercase" *ngIf="channel === 'email'">
        {{ data }}
    </span>
    <form [formGroup]="resetForm">
        <app-responsive-input *ngIf="componentState !== 'codeOk'"
            controlName="codeNumber"
            type="text"
            placeholder="Ingresa el codigo"
            [enableLabel]="false"
            [enableEnterEvent]="true"
            minLength="6"
            maxLength="6"
            [viewElementRef]="viewElementRef">
        </app-responsive-input>
        <div *ngIf="resetForm.get('codeNumber').hasError('invalidCode')">
            El código proporcionado es invalido. Intenta de nuevo.
        </div>
    </form>
    <div *ngIf="componentState === 'codeOk'"
        class="animation-container alert alert-success mt-3">
        <app-checkmark class="animation-code-ok"
            [@stateOpacity]="animationCodeDescOk">
        </app-checkmark>
        <div class="animation-code-ok"
            [@stateOpacity]="animationCodeDescOk">
            Su código fue verificado correctamente.
        </div>
    </div>
    <button [@stateOpacity]="animationBtnOk"
        class="w-100 role-action-btn mt-3"
        [disabled]="resetForm.invalid"
        mat-raised-button
        (click)="sendCode()"
        [loading]="loadingSendCode">
        Verificar código
    </button>
<!--    <mat-divider *ngIf="componentState !== 'codeOk'"></mat-divider>-->
    <div [@stateOpacity]="animationBtnOk" class="resend-code glance-card-theme-color p-3 mt-3">
        <p class="small-label">¿No recibiste el código de verificación?</p>
        <div style="font-weight: bold">{{ counter | date: 'mm:ss' }}</div>
        <button mat-button
            class="w-100 link-action-btn-2"
            [@stateOpacity]="animationTimerEnd"
            (click)="resendCodeSMS(data)"
            [loading]="loadingResendSMS">
            Reenviar código
        </button>
        <div [@stateOpacity]="animationSMSResended">
            Se envío un nuevo código al {{ channel === 'sms' || channel === 'wa' ? 'número de teléfono' : 'correo electrónico' }}
            <br />
            <span style="font-weight: bold" *ngIf="channel !== 'email'">
                {{ data | mask : (country === 'mexico' ? '00 (000) 000-0000' : '0 (000) 000-0000') }}
            </span>
            <span style="font-weight: bold" *ngIf="channel === 'email'">
                {{ data }}
            </span>
        </div>
    </div>
</div>
